import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { DarkSkyKey } from 'app/interfaces/darksky';

@Injectable()
export class DarkSkyService extends BaseService<DarkSkyKey>{
    rootUrl = "weatherKeys";
}